import React from 'react';
import { useHistory } from 'react-router-dom';
import {
    LISTING_STATE_CLOSED,
    LISTING_STATE_DRAFT,
    LISTING_STATE_PENDING_APPROVAL,
    LISTING_STATE_PUBLISHED,
} from '../../util/types';
import ActionWrapper from './ActionWrapper';
import { getListingNavParams } from '../../util/listings';
import { createResourceLocatorString, EDIT_LISTING_PAGE } from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';
import { TertiaryButton } from '../Button/Button';
import css from './StatisticsSectionActions.css';
import ListingStatistics from './ListingStatistics';
import { useReactivateListing } from '../../hooks/useReactivateListing';

const StatisticsSectionActionsHorse = ({ currentListing }) => {
    const history = useHistory();
    const reactivateListing = useReactivateListing(currentListing);

    const { uuid: listingId } = currentListing?.id || {};
    const { state } = currentListing?.attributes || {};
    const isPendingApproval = state === LISTING_STATE_PENDING_APPROVAL;
    const isClosed = state === LISTING_STATE_CLOSED;
    const isDraft = state === LISTING_STATE_DRAFT;
    const isPublished = state === LISTING_STATE_PUBLISHED;

    if (listingId && isDraft) {
        return (
            <ActionWrapper>
                <TertiaryButton
                    type="button"
                    onClick={() => {
                        const { params } = getListingNavParams(currentListing);
                        history.push(
                            createResourceLocatorString(EDIT_LISTING_PAGE, routeConfiguration(), {
                                ...params,
                                type: 'draftInterrupted',
                                tab: 'overview',
                            })
                        );
                    }}
                >
                    Profil vervollständigen
                </TertiaryButton>
            </ActionWrapper>
        );
    }
    if (listingId && isPendingApproval) {
        return (
            <ActionWrapper rootClassName={css.noActionAllowed}>
                <span>Überprüfung abwarten</span>
            </ActionWrapper>
        );
    }
    if (listingId && isPublished) {
        return <ListingStatistics currentListing={currentListing} />;
    }
    if (listingId && isClosed) {
        return (
            <ActionWrapper>
                <TertiaryButton type="button" onClick={reactivateListing}>
                    Profil reaktivieren
                </TertiaryButton>
            </ActionWrapper>
        );
    }
    return null;
};
export default StatisticsSectionActionsHorse;
